import { ICardDataViewModel } from '../../shared/models/models';
import { GraphicBehaviorType } from '../../shared/models/graphic-behavior-type.enum';
import { IDeviceNode, NumberSensorInputMap } from '@caslink/device-client/ng-app/shared/models/device';

export class GraphicCardData implements ICardDataViewModel {
    public data: IDeviceNode;
    public name = '';
    public value: string;
    public actualValue: any;
    public displayValue: string;

    public isCategory = false;
    public isVisible = true;
    public isGraphicBehavior = true;

    public graphicBehavior: GraphicBehaviorType | string;
    public maxValue?: number;
    public minValue?: number;
    public sensorId?: number;
    public isEnabled?: boolean;
    public order?: number;
    public numberSensorInputMap?: NumberSensorInputMap;
    public valueSet?: number[];
    public indent: number;
    public hidableKeys: string[];
    public section?: string;
    public categories: string[];

    constructor(
        _data: IDeviceNode,
        _displayValue: string,
        _numberSensorInputMap?: NumberSensorInputMap,
        _indent?: number,
        _hidableKeys?: string[],
        _categories?: string[]
    ) {
        this.data = _data;
        this.name = _data.displayText;
        this.displayValue = _displayValue;
        this.value = _displayValue;
        this.actualValue = _data.value;
        this.graphicBehavior = GraphicBehaviorType[_data.graphicBehavior];
        this.isVisible = _data.isVisible;
        this.isEnabled = _data.isEnabled;
        this.minValue = _data.minValue;
        this.maxValue = _data.maxValue;
        this.sensorId = _data.sensorId;
        this.order = _data.order;
        this.numberSensorInputMap = _numberSensorInputMap;
        this.valueSet = _data.valueSet;
        this.indent = _indent;
        this.hidableKeys = _hidableKeys;
        this.categories = _categories;
    }
}
